var _excluded = ["aria-label", "aria-labelledby", "aria-describedby", "aria-details", "marginX", "marginY", "width", "height", "minWidth", "minHeight", "maxWidth", "maxHeight", "flex", "flexGrow", "flexShrink", "flexBasis", "justifySelf", "alignSelf", "order", "gridArea", "gridColumn", "gridRow", "gridColumnStart", "gridColumnEnd", "gridRowStart", "gridRowEnd", "position", "zIndex", "top", "bottom", "start", "end", "left", "right", "isHidden"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Separate props for Spectrum components into AriaLabelingProps, StyleProps, and
 * any remaining props.
 * @param props The props to separate
 * @returns The separated props
 */
export function separateSpectrumProps(props) {
  var ariaLabel = props['aria-label'],
    ariaLabelledby = props['aria-labelledby'],
    ariaDescribedby = props['aria-describedby'],
    ariaHidden = props['aria-details'],
    marginX = props.marginX,
    marginY = props.marginY,
    width = props.width,
    height = props.height,
    minWidth = props.minWidth,
    minHeight = props.minHeight,
    maxWidth = props.maxWidth,
    maxHeight = props.maxHeight,
    flex = props.flex,
    flexGrow = props.flexGrow,
    flexShrink = props.flexShrink,
    flexBasis = props.flexBasis,
    justifySelf = props.justifySelf,
    alignSelf = props.alignSelf,
    order = props.order,
    gridArea = props.gridArea,
    gridColumn = props.gridColumn,
    gridRow = props.gridRow,
    gridColumnStart = props.gridColumnStart,
    gridColumnEnd = props.gridColumnEnd,
    gridRowStart = props.gridRowStart,
    gridRowEnd = props.gridRowEnd,
    position = props.position,
    zIndex = props.zIndex,
    top = props.top,
    bottom = props.bottom,
    start = props.start,
    end = props.end,
    left = props.left,
    right = props.right,
    isHidden = props.isHidden,
    componentProps = _objectWithoutProperties(props, _excluded);
  return {
    ariaLabelProps: {
      'aria-label': ariaLabel,
      'aria-labelledby': ariaLabelledby,
      'aria-describedby': ariaDescribedby,
      'aria-details': ariaHidden
    },
    styleProps: {
      marginX,
      marginY,
      width,
      height,
      minWidth,
      minHeight,
      maxWidth,
      maxHeight,
      flex,
      flexGrow,
      flexShrink,
      flexBasis,
      justifySelf,
      alignSelf,
      order,
      gridArea,
      gridColumn,
      gridRow,
      gridColumnStart,
      gridColumnEnd,
      gridRowStart,
      gridRowEnd,
      position,
      zIndex,
      top,
      bottom,
      start,
      end,
      left,
      right,
      isHidden
    },
    componentProps: componentProps
  };
}
export default separateSpectrumProps;
//# sourceMappingURL=propsUtils.js.map